"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "asOfDate": "2022-03-29T00:00:00",
    "data": [
        {
            "securityKey": "sec_624e5741b6d243178ecaf187b370f669",
            "securityCode": "ANZ.ASX",
            "securityName": "Australia & New Zealand Banking Group Ltd.",
            "units": 7814.000000,
            "price": 27.610000,
            "value": 215744.54,
            "costBase": 204635.912500,
            "estimatedGainOrLoss": 12515.14750000,
            "percentageOfPortfolio": 0.075337,
            "assetClassKey": "ac_a3feff965110450db92d87bde98e12dc",
            "assetClassName": ""
        },
        {
            "securityKey": "sec_12d8fcc7531e4afdb2eb583af896f121",
            "securityCode": "BHP.ASX",
            "securityName": "BHP Group Limited",
            "units": 2172.000000,
            "price": 49.770000,
            "value": 108100.44,
            "costBase": 52294.270000,
            "estimatedGainOrLoss": 58303.97000000,
            "percentageOfPortfolio": 0.037748,
            "assetClassKey": "ac_6531a08c235947679b810ce843b3ed29",
            "assetClassName": "Australian Cash"
        },
        {
            "securityKey": "sec_0e329d40e51d4b9db72b48516fd056ce",
            "securityCode": "ANZPG.ASX",
            "securityName": "ANZ Capital Notes 4",
            "units": 3337.000000,
            "price": 105.940000,
            "value": 353521.78,
            "costBase": 350423.230000,
            "estimatedGainOrLoss": 2431.15000000,
            "percentageOfPortfolio": 0.123449,
            "assetClassKey": "ac_f9b759f1c5f1462797aff3db83fbd584",
            "assetClassName": "Australian Fixed Income"
        },
        {
            "securityKey": "sec_de09e0ba007747b48eaad7f2b98e3ac1",
            "securityCode": "ABC.ASX",
            "securityName": "Adbri Limited",
            "units": 1000.000000,
            "price": 3.110000,
            "value": 3110.00,
            "costBase": 3000.000000,
            "estimatedGainOrLoss": 80.00000000,
            "percentageOfPortfolio": 0.001086,
            "assetClassKey": "ac_110b35303e184b808b8342c8d0d288b9",
            "assetClassName": "Australian Shares"
        }
    ]
};
